import axios, { AxiosResponse } from 'axios';

import elementSpy, { Bound, ElementSpyInstance } from 'bloko/common/elementSpy';
import urlParser from 'bloko/common/urlParser';

import { getDefaultAnalyticsParams } from './initAnalyticsParams';

export interface AnalyticsParams {
    hhtmSource?: string;
    hhtmFrom?: string;
    originalRequestId?: string;
    goal?: string;
    event?: string;
    name?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: Record<string, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [x: string]: any;
}

export function sendPostRequest(
    analyticsParams: AnalyticsParams = {},
    bodyData: AnalyticsParams = {}
): Promise<AxiosResponse<void> | void> {
    const queryParams: AnalyticsParams = {
        ...getDefaultAnalyticsParams(),
        ...analyticsParams,
        originalRequestId: analyticsParams.originalRequestId || window.globalVars?.requestId,
    };

    try {
        const body = urlParser.stringify(bodyData);
        const headers = {
            type: 'application/x-www-form-urlencoded',
        };
        const blob = new Blob([body], headers);
        const sendStatus = navigator.sendBeacon(`/analytics?${urlParser.stringify(queryParams)}`, blob);
        if (sendStatus) {
            return Promise.resolve();
        }
    } catch (_ignore) {} // eslint-disable-line
    return axios.post('/analytics', urlParser.stringify(bodyData), { params: queryParams }).catch(console.error);
}

export function sendHHEvent(event: string, params: AnalyticsParams = {}, bodyData: AnalyticsParams = {}): void {
    void sendPostRequest({ event, ...params }, bodyData);
}

export function sendHHEventButtonClick(
    buttonName: string,
    params: AnalyticsParams = {},
    bodyData: AnalyticsParams = {}
): void {
    void sendHHEvent(
        'button_click',
        {
            buttonName,
            ...params,
        },
        bodyData
    );
}

export function sendHHEventElementShown(
    element: HTMLElement,
    analyticsParams: AnalyticsParams = {},
    bodyData: AnalyticsParams = {},
    spyParams?: {
        trackingBounds?: Bound[];
        elementLockTime?: number;
    }
): ElementSpyInstance {
    let isAnalyticsSent = false;
    const handleElementShown = () => {
        if (isAnalyticsSent) {
            return;
        }

        isAnalyticsSent = true;

        const { name, ...eventData } = analyticsParams;
        void sendHHEvent('element_shown', { elementName: name, ...eventData }, bodyData);
    };
    return elementSpy(element, {
        onShow: handleElementShown,
        ...{
            ...spyParams,
            trackingBounds: spyParams?.trackingBounds || [Bound.Top],
        },
    });
}
